import sgold from "../images/getGoldButton.png";
import mark from "../images/exclamationMark.png";
import endLine from "../images/endLine.png";
import graphs from "../images/graphs.png";
import QMark from "../images/questionMark.png";
import asset1 from "../images/Asset111.png";
import asset2 from "../images/Asset112.png";
import asset3 from "../images/Asset113.png";
import asset4 from "../images/asset114.png";
import SGOLD from "../images/SGOLD1.svg";
import SGOLD1 from "../images/SGOLD1.png";
import SGOLDtransparent from "../images/SwissGold-Transparent.png";
import SgoldBlur from "../images/swisGold-Blur.svg";
import heroText from "../images/heroText.png";
import swapImg1 from "../images/swapImage1.svg";
import swapImg2 from "../images/swapImage2.svg";
import swapImg3 from "../images/Group 665.svg";
import swapImg4 from "../images/swapgoldBg1.svg";

import Navbar from "../components/navbar";
import { useEffect, useState } from "react";
import FlareEffect from "../components/flareEffect";

const Home = () => {
  const [image, setImage] = useState(swapImg1);
  function ChangeImage() {
    setImage((prevImage) => (prevImage === swapImg1 ? swapImg2 : swapImg1));
  }
  useEffect(() => {
    const interval = setInterval(ChangeImage, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <div className="">
      <Navbar />
      <section className="max-w-[1400px] mx-auto">
        <section>
          <div className="flex flex-col md:flex-row mx-auto items-center justify-center px-5">
            <div className="relative flex max-w-[600px]  items-center justify-center ">
              <img
                className="absolute top-1/3 left-[20%] w-[30%] -translate-x-1/2 -translate-y-1/2 animate-float "
                src={SgoldBlur}
                alt="Swissgold"
              />

              <img className="z-10" src={SGOLDtransparent} alt="Swissgold" />
              <img
                className="z-10 absolute left-[10%] bottom-[20%] w-[30%]"
                src={SGOLD}
                alt="Swissgold"
              />
              <img
                className="absolute top-1/3 right-[15%] w-[30%] -translate-x-1/2 -translate-y-1/2 animate-float "
                src={SgoldBlur}
                alt="Swissgold"
              />
            </div>
            <div className="w-full  md:w-[50%]">
              <img src={heroText} alt="welcome to Swiss Gold" />
              <div className="flex mt-10 flex-wrap items-start md:items-start justify-center md:justify-start">
                <button className="shadow-yellow-300 relative m-3 shadow-[0_0_50px_rgba(0,0,0,0.3)]  hover:scale-105  transition-transform ease-in-out duration-300 bg-gradient-to-r from-gray-900 to-gray-800 flex items-center justify-center border-gray-400 border-t-[2px] p-5 py-4 rounded-full text-yellow-400 font-bold">
                  <div className="absolute w-[50px] h-[50px] top-0 right-0 -mt-5">
                  <FlareEffect />
                  </div>
                  <img className="w-[50px] mr-2" src={SGOLD1} alt="GetGold" />
                  Get $SGOLD Now
                </button>
                <button className="shadow-yellow-300 m-3 shadow-[0_0_50px_rgba(0,0,0,0.3)]  hover:scale-105  transition-transform ease-in-out duration-300 relative bg-gradient-to-r from-yellow-400 to-yellow-500 flex items-center justify-center border-gray-200 border-t-[1px] p-5 py-4 rounded-full text-gray-800 font-bold">
                  <div className="absolute w-[50px] h-[50px] top-0 right-0 -mt-5">
                  <FlareEffect />
                  </div>
                  <img className="w-[50px] mr-2" src={SGOLD1} alt="GetGold" />
                  Withdraw SGOLD
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="flex-col md:flex-row mt-7 flex items-center justify-between px-8 md:px-20 py-8">
          <div className="w-full md:w-[50%] flex flex-row justify-center">
            <div className="flex  justify-start">
              <div className="w-[100px]">
                <img src={mark} alt="?" />
              </div>

              <div className="w-[100%]">
                <h1 className="text-4xl md:text-5xl  font-bold">
                  AI Gold Trading <br /> With
                  <span className="text-yellow-400">$SGOLD</span>
                </h1>
                <div className="w-[25px] h-[2px] mt-6 bg-yellow-400"></div>
                <p className="mt-4 pr-3">
                  SwissGold is the most modern way of gold investing. You can
                  use your $SWCH yokens and receive $SGOLD tokens. Our advanced
                  trading bots trade with your assets and make profit for you.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center max-w-[600px] md:w-[45%]">
            <div className="relative  p-8">
              <img
                className="absolute top-0 w-[40%] right-0 backdrop-blur-sm"
                src={swapImg3}
                alt="aldft"
              />
              <div className="">
                <img
                  className={` inset-0 w-full  h-full object-cover rounded-xl 
                transition-all duration-1000 ease-in-out opacity-100  `}
                  src={image}
                  alt="ddd"
                />
              </div>
              <img
                className="absolute bottom-3 -z-10 left-3  w-[40%]"
                src={swapImg4}
                alt="aldft"
              />
            </div>
          </div>
        </section>
        <div className="flex justify-center">
          <img src={endLine} alt="n" />
        </div>
        <section className="px-6 md:px-28 py-8 mt-5 ">
          <div className=" md:flex-row flex-col-reverse justify-center flex items-center">
            <div className="w-full mt-5 flex justify-center md:w-[50%]">
              <img className="max-w-[70%]" src={graphs} alt="graph" />
            </div>
            <div className="w-full relative md:w-[50%] flex">
              <div>
                <img
                  className="absolute top-0 left-0 w-[100px] md:w-[100px]"
                  src={QMark}
                  alt=" "
                />
              </div>
              <div className="ml-20">
                <h1 className="text-3xl md:text-5xl  font-bold">
                  Why <span className="text-yellow-400">Gold</span> is the Best
                  Investment?
                </h1>
                <div className="w-[25px] h-[2px] mt-6 bg-yellow-400"></div>
                <p className="mt-5">
                  Gold can be a hedge against inflation because its price tends
                  to rise when the cost of living increases. Investors can
                  periodically see gold prices soar and the stock market plunge
                  during high-inflation years.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 py-8 ">
            <h1 className="text-4xl font-bold text-center">How it Works?</h1>
            <div className="flex flex-wrap justify-center">
              <div className="w-[180px] text-center mx-2">
                <img src={asset1} alt="Exchange Your Gold" />
                <h1 className="text-lg text-yellow-400">
                  Exchange your $SWCH to $SGOLD
                </h1>
              </div>
              <div className="w-[180px] text-center mx-2">
                <img src={asset2} alt="Use Your Token" />
                <h1 className="text-lg text-yellow-400">
                  Use your $SGOLD Tokens and buy Gold
                </h1>
              </div>
              <div className="w-[180px] text-center mx-2">
                <img src={asset3} alt="start making profit" />
                <h1 className="text-lg text-yellow-400">
                  Start Making Profit With AI Trading
                </h1>
              </div>
            </div>
          </div>
        </section>
        <div className="flex justify-center">
          <img src={endLine} alt="nd" />
        </div>
        <section className="px-6 md:px-28 py-8 mt-5 flex flex-col items-center">
          <h1 className="text-4xl font-bold text-center">
            {" "}
            <span className="text-yellow-400">SwissGold</span> is the New Era of
            Investment
          </h1>
          <p className="text-center w-[90%] md:w-[70%] mt-5">
            SwissGold is the most modern way of gold investing. You can use your
            $SWCH yokens and receive $SGOLD tokens. Our advanced trading bots
            trade with your assets and make profit for you. SwissGold is the
            most modern way of gold investing.
          </p>
          <img src={asset4} alt="get your gold bar" className="mt-8" />
          <div className=" flex flex-col justify-center items-center">
            <p className="text-4xl font-bold text-center">
              Get Your <span className="text-yellow-400">Gold Bars</span> Before
              it’s Late!
            </p>
            <h3 className="font-bold text-2xl text-center mt-3">
              Join SwissGold at a Fearless Journey
            </h3>
            <button className=" z-10  w-fit">
              <img
                className="hover:scale-105 mx-auto"
                width={"530px"}
                alt="dd"
                src={sgold}
              />
            </button>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Home;
